"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextArea = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const TextArea_1 = tslib_1.__importDefault(require("antd/es/input/TextArea"));
exports.TextArea = React.forwardRef((_a, ref) => {
    var { className = '' } = _a, allProps = tslib_1.__rest(_a, ["className"]);
    return (React.createElement(TextArea_1.default, Object.assign({}, allProps, { className: `clp-textarea ${className}`, ref: ref })));
});
//# sourceMappingURL=TextArea.js.map